// import {get} from "@/js/lib/api"
import { stringify } from 'qs';

const comments = {
  namespaced: true,
  state: () => ({
    list: [],
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0
    }
  }),

  mutations: {},

  actions: {
    async fetch(commit, {payload}) {
      const res = await window.axios.get(`/api/store/comments?${stringify(payload)}`)

      // const { response, data } = res;

      return res;
    }
  }
}

export default comments
